<template>
  <div class="u-prescription">
    <div class="cf-info">
      <div class="row">
        <div class="item">
          <span class="label">主诉:</span>
          <span class="value">{{ detailInfo.purposeOfConsultationName }}</span>
        </div>
        <div class="item">
          <span class="label">诊断:</span>
          <span class="value">{{ detailInfo.diseaseTypeName }}</span>
        </div>
        <div class="item"></div>
      </div>
      <div class="row">
        <div class="item">
          <span class="label">医馆:</span>
          <span class="value">{{ detailInfo.hospitalName }}</span>
        </div>
        <div class="item">
          <span class="label">医生:</span>
          <span class="value">{{ detailInfo.doctorName }}</span>
        </div>
        <div class="item">
          <span class="label">就诊时间:</span>
          <span class="value">{{ detailInfo.visitTime }}</span>
        </div>
      </div>
      <div class="info-title">症状</div>
      <div class="row">
        <div class="item">
          <span class="label label2">【保持】</span>
          <span class="value">{{ zz.bc || "无" }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <span class="label label2">【减轻】</span>
          <span class="value">{{ zz.jq || "无" }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <span class="label label2">【加重】</span>
          <span class="value">{{ zz.jz || "无" }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <span class="label label2">【增】</span>
          <span class="value">{{ zz.add || "无" }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <span class="label label2">【减】</span>
          <span class="value">{{ zz.remove || "无" }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <span class="label label2">【患者自述】</span>
          <span class="value">{{ detailInfo.chiefComplaint }}</span>
        </div>
      </div>
      <div class="info-title">医生处方</div>
      <div class="value">{{ detailInfo.hisDrugStr }}</div>
      <div class="info-title">系统处方</div>
      <div class="value" v-html="detailInfo.sanfangDrugStr || '无'"></div>
      <div class="info-title">医生用药差异(加药)</div>
      <div class="value" v-html="detailInfo.addDrugStr || '无'"></div>
      <div class="info-title">医生用药差异(删药)</div>
      <div class="value" v-html="detailInfo.removeDrugStr || '无'"></div>

      <div v-if="drugListByDialectic.length">
        <div class="info-title">医生用药禁忌提示</div>
        <div class="value">
          <div
            v-for="(item, index) in drugListByDialectic"
            :key="index"
            class="taboo-item"
          >
            {{ index + 1 }}、{{ item.dialecticName }}：{{
              item.drugList.length ? item.drugList.join("、") : "暂无内容"
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["diagnosticList2", "dicts"]),
    Dialectic_Taboo_Drug() {
      let list = this.dicts.Dialectic_Taboo_Drug || [];
      let tabooDrugList = [];
      let arr = list
        .filter((i) => this.dialecticNames.includes(i.string1))
        .map((i) => {
          let drugList = i.string2.split(",");
          tabooDrugList.push(...drugList);
          return {
            dialecticName: i.string1,
            drugList,
          };
        });
      this.$emit("tabooDrugList", tabooDrugList);
      return arr;
    },
    drugListByDialectic() {
      console.log("=====55=>", this.detailInfo);

      if (this.detailInfo.hisDrugList) {
        let dList = this.detailInfo.hisDrugList.map((i) => i.label);
        // dList.push("佩兰"); // 测试
        return this.common.clone(this.Dialectic_Taboo_Drug).filter((i) => {
          i.drugList = i.drugList.filter((d) => dList.includes(d));
          return i.drugList.length > 0;
        });
      } else {
        return [];
      }
    },
  },
  watch: {
    detailInfo(newValue, oldValue) {
      this.setData();
    },
  },
  data() {
    return {
      zz: {
        jz: "",
        jq: "",
        bc: "",
        same: "",
        add: "",
        remove: "",
      },
      dialecticInfo: [],
      dialecticNames: [],
    };
  },
  methods: {
    setData() {
      if (this.detailInfo.diseaseCode) {
        let r = this.getDiseaseName(
          this.detailInfo.diseaseCode,
          this.detailInfo.lastDiseaseCode
        );
        Object.assign(this.zz, r);
        this.getDialecticInfoByKey();
      }
    },
    // 症状分成减轻、加重、保持、增、减、患者自述几个维度来显示
    // 0 保持 1 重  2 轻
    getDiseaseName(diseaseCode, lastDiseaseCode) {
      let dList = [];
      let arr = diseaseCode.split("|");
      let labels1 = [];
      arr.forEach((item) => {
        if (item) {
          let value = item.split("&")[0];
          let label = this.common.valueToLabel(this.diagnosticList2, value);
          if (label) {
            let level = item.split("&")[1] || "0";
            labels1.push(label);
            dList.push({
              value,
              level,
              label,
            });
          }
        }
      });
      let jz = dList
        .filter((i) => i.level == "1")
        .map((i) => i.label)
        .join("，"); //加重
      let jq = dList
        .filter((i) => i.level == "2")
        .map((i) => i.label)
        .join("，"); //减轻
      let bc = dList
        .filter((i) => i.level == "0")
        .map((i) => i.label)
        .join("，"); //保持

      let r = { same: [], add: [], remove: [] };
      if (lastDiseaseCode != "‘’") {
        let labels2 = lastDiseaseCode
          .replace(/&\d+/g, "")
          .split("|")
          .filter((i) => i)
          .map((i) => this.common.valueToLabel(this.diagnosticList2, i));
        Object.assign(r, this.common.differ(labels2, labels1));
      }
      return {
        jz,
        jq,
        bc,
        same: r.same.join("，"),
        add: r.add.join("，"),
        remove: r.remove.join("，"),
      };
    },
    getDialecticInfoByKey() {
      this.api2("getDialecticInfoByKey", {
        prescriptionNo: this.detailInfo.prescriptionNo,
      }).then((res) => {
        // 测试
        // res.result.dialecticInfo = '[{"dialecticName":"风热犯肺证","type":1},{"dialecticName":"脾气虚证","type":2}]';
        let obj = res.result.dialecticInfo;
        this.dialecticInfo = obj ? JSON.parse(obj) : [];
        this.dialecticNames = this.dialecticInfo.map((i) => i.dialecticName);
      });
    },
  },
  mounted() {
    this.$store.dispatch("getWideUseList", "Dialectic_Taboo_Drug");
    this.setData();
  },
};
</script>

<style scoped lang="scss">
.u-prescription {
  .more-btn {
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    opacity: 0.6;
  }
}
</style>